import { gql } from '@apollo/client';

const LIST_ECG_BOOKMARKS_QUERY = gql`
  query listEcgBookmarks($filter: ListEcgBookmarksFilter!, $limit: Int) {
    listEcgBookmarks(filter: $filter, limit: $limit) {
      isSuccess
      message
      ecgBookmarks {
        id
        start
        stop
        notes
      }
    }
  }
`;

export default LIST_ECG_BOOKMARKS_QUERY;
